export default __webpack_public_path__ + "static/webinar_banner_1920-317a80521d7e27acc4b8cec5670eba34.png";